export default __webpack_public_path__ + "static/media/addProfilePic.3eaca7f1.svg";